(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["loading"] && !Shopify.designMode) return;
  try {
    const loader = document.querySelector(".loading-overlay");
  if (!loader) return;

  const delay = parseInt(loader.dataset.delay || "1000", 10);

  setTimeout(() => {
    // document.documentElement.classList.remove("page-loading");
  loader.style.opacity = '0';
  loader.style.visibility = 'hidden';
  loader.style.pointerEvents = 'none';
  }, delay);
  } catch(e) { console.error(e); }
})();

})();
